'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _quicksend = require('redux/modules/quicksend');

var quickSendActions = _interopRequireWildcard(_quicksend);

var _components = require('components');

var _project = require('redux/modules/project');

var _contacts = require('redux/modules/contacts');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./QuickSendNew.scss');

var QuickSendNew = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    dispatch((0, _project.initProject)());
    dispatch((0, _project.initSubmittedFiles)());
    dispatch((0, _contacts.loadGroups)());
    return (0, _asyncPromise2.default)(dispatch(quickSendActions.qsCreate()).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    projectId: (0, _get4.default)(state.quicksend, 'qsCreateData.projectId', 0),
    qsCreateLoadError: state.quicksend.qsCreateLoadError,
    qsCreateLoading: state.quicksend.qsCreateLoading
  };
}, (0, _extends3.default)({}, quickSendActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QuickSendNew, _Component);

  function QuickSendNew() {
    (0, _classCallCheck3.default)(this, QuickSendNew);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendNew.__proto__ || (0, _getPrototypeOf2.default)(QuickSendNew)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendNew, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          qsCreateLoading = _props.qsCreateLoading,
          qsCreateLoadError = _props.qsCreateLoadError,
          projectId = _props.projectId;


      return _react2.default.createElement(
        'div',
        { className: styles.page },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Create Quick Send' }),
        _react2.default.createElement(
          'div',
          { className: styles.container },
          _react2.default.createElement(
            'div',
            { className: styles.content },
            qsCreateLoading ? _react2.default.createElement(_components.Loader, null) : qsCreateLoadError ? _react2.default.createElement(
              'div',
              { className: 'error' },
              qsCreateLoadError.msg
            ) : _react2.default.createElement(_components.QuickSendForm, { projectId: projectId })
          )
        )
      );
    }
  }]);
  return QuickSendNew;
}(_react.Component), _class2.propTypes = {
  projectId: _propTypes2.default.number,
  qsCreateLoadError: _propTypes2.default.object,
  qsCreateLoading: _propTypes2.default.bool
}, _temp)) || _class) || _class);
exports.default = QuickSendNew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuickSend/QuickSendNew/QuickSendNew.js
// module id = 2207
// module chunks = 1